import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { BusyStateDialog } from '@sas/nova-commons/components/BusyStateDialog';
import { MessageDialog, useMessageDialogText } from '@sas/nova-commons/components/MessageDialog';
import { Dialog as BasicDialog } from '@sas/nova-commons/components/Dialog';
import { Select } from '@sas/nova-commons/components/Select';
import { withLabels } from '@sas/nova-commons/components/withLabels';
import { useI18n } from '../../../../locale/I18nContext';
import cn from './Dialog.css.json';
import './Dialog.css';
const SelectWithLabels = withLabels(Select);
export const LoadingDialog = (props) => {
    const localize = useI18n();
    return (_jsx(BusyStateDialog, { title: localize({ key: 'PinPanel.findMyLocation.txt' }), isOpen: props.isOpen, showCancelButton: true, onDismiss: props.onDismiss }));
};
export const ErrorDialog = (props) => {
    const localize = useI18n();
    const { CLOSE } = useMessageDialogText();
    return (_jsx(MessageDialog, { dismissAction: {
            text: CLOSE,
            onPress: props.onDismiss,
        }, title: localize({ key: 'PinPanel.findMyLocation.txt' }), type: "error", isOpen: props.isOpen, text: localize({ key: 'PinPanel.cannotDetermineLocation.txt' }) }));
};
const calculateIntervalFromSeconds = (seconds = 0) => {
    return {
        hours: Math.floor(seconds / 3600),
        minutes: Math.floor(seconds / 60) % 60,
        seconds: seconds % 60,
    };
};
export const IntervalDialog = (props) => {
    const localize = useI18n();
    const { CANCEL, OK } = useMessageDialogText();
    const [selectedInterval, setSelectedInterval] = useState(calculateIntervalFromSeconds(props.interval));
    return (_jsx(BasicDialog, Object.assign({ isOpen: props.isOpen, title: localize({ key: 'PinPanel.autoRefreshInterval.txt' }), firstAction: {
            text: OK,
            onPress: () => {
                var _a;
                const totalSeconds = selectedInterval.hours * 3600 +
                    selectedInterval.minutes * 60 +
                    selectedInterval.seconds;
                (_a = props.onPress) === null || _a === void 0 ? void 0 : _a.call(props, totalSeconds);
            },
            isDefault: true,
        }, dismissAction: {
            text: CANCEL,
            onPress: () => {
                var _a;
                (_a = props.onDismiss) === null || _a === void 0 ? void 0 : _a.call(props);
                setSelectedInterval(calculateIntervalFromSeconds(props.interval));
            },
        } }, { children: _jsxs("div", Object.assign({ className: cn.timeInput }, { children: [_jsx(SelectWithLabels, { label: localize({ key: 'PinPanel.interval.hours.txt' }), values: [...Array(24).keys()].map((hour) => ({ text: hour })), selectedIndex: selectedInterval.hours, onSelected: (i) => {
                        if (i || i === 0) {
                            setSelectedInterval(Object.assign(Object.assign({}, selectedInterval), { hours: i }));
                        }
                    } }), _jsx("span", Object.assign({ className: cn.separator }, { children: " : " })), _jsx(SelectWithLabels, { label: localize({ key: 'PinPanel.interval.minutes.txt' }), values: [...Array(60).keys()].map((minute) => ({ text: minute })), selectedIndex: selectedInterval.minutes, onSelected: (i) => {
                        if (i || i === 0) {
                            setSelectedInterval(Object.assign(Object.assign({}, selectedInterval), { minutes: i }));
                        }
                    } }), _jsx("span", Object.assign({ className: cn.separator }, { children: " : " })), _jsx(SelectWithLabels, { label: localize({ key: 'PinPanel.interval.seconds.txt' }), values: [...Array(60).keys()].map((second) => ({ text: second })), selectedIndex: selectedInterval.seconds, onSelected: (i) => {
                        if (i || i === 0) {
                            setSelectedInterval(Object.assign(Object.assign({}, selectedInterval), { seconds: i }));
                        }
                    } })] })) })));
};
